import { make as RecaptchaProvider } from '@porterin/feature/src/contexts/recpatcha-context/RecaptchaProvider.mjs';
import {
  CityService,
  FareEstimateContent,
} from '@porterin/feature/src/shared/cities/domain/entities/CitiesEntity';
import { reloadAfterRecaptchaFailure } from '@porterin/feature/src/shared/core/helpers/SharedHelper';
import { LeadFlowContentEntity } from '@porterin/feature/src/shared/lead-flow/domain/entities/LeadFlowContentEntity';
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { MODAL_CLOSE_TIMEOUT_NONE } from '../../domain/entities/ModalEntities';
import styles from '../styles/FareEstimateModal.module.scss';

import FareEstimateHomeModalCmp from './FareEstimateHomeModalCmp';

interface FareEstimateModalCmpProps {
  modalState: boolean;
  close_modal: () => void;
  category_cards_data: CityService[];
  fare_estimate_form_content: LeadFlowContentEntity;
  modal_content: FareEstimateContent;
}

function FareEstimateModalCmp({
  modalState,
  close_modal,
  category_cards_data,
  fare_estimate_form_content,
  modal_content,
}: Readonly<FareEstimateModalCmpProps>): React.ReactElement {
  const [isRecaptchaFailed, setIsRecaptchaFailed] = useState(false);

  useEffect(
    () => reloadAfterRecaptchaFailure(isRecaptchaFailed),
    [isRecaptchaFailed],
  );

  return (
    <ReactModal
      isOpen={modalState}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_NONE}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <RecaptchaProvider
        value={{
          isRecaptchaFailed,
          setRecaptchaState: (flag: boolean) => setIsRecaptchaFailed(flag),
        }}
      >
        <FareEstimateHomeModalCmp
          close_modal={close_modal}
          category_cards_data={category_cards_data}
          fare_estimate_form_content={fare_estimate_form_content}
          modal_content={modal_content}
        />
      </RecaptchaProvider>
    </ReactModal>
  );
}

export default FareEstimateModalCmp;
